// 展开区不恢复主表特意保留的字段，不绕过电话号码权限。
export function overflowKeys(hidden: string[], omitted: string[], mainOnly: string[] = []): Set<string> {
  return new Set([...hidden, ...omitted].filter(key => !mainOnly.includes(key)))
}
export function safeOverflowText(value: unknown, field: string, canViewPhone: boolean): string {
  const text = value == null ? '—' : String(value)
  if(isAddressField(field))return safeAddressText(value,canViewPhone)
  if (!canViewPhone && /(phone|mobile|tel|loginName)/i.test(field)) return text.replace(/\d{11,}/g, phone => phone.slice(0,3)+'*****'+phone.slice(8))
  return text
}

// 仅识别地址类组合字段，不对订单号、款号、金额或普通数字做全局替换。
export function isAddressField(field:unknown):boolean {
 return /(address|收货地址|退货地址|联系地址|地址信息)/i.test(String(field || ''))
}
export function maskAddressPhones(value:unknown):string {
 const original=value==null?'':String(value)
 // 等长归一化仅用于识别，返回时保留原地址格式；兼容全角数字及常见复制空格。
 let text=original.replace(/[０-９]/g,char=>String(char.charCodeAt(0)-0xFF10)).replace(/[\u00a0\u2000-\u200b\u202f\u3000]/g,' ').replace(/[‐‑‒–—−]/g,'-').replace(/＋/g,'+')
 const normalized=text
 const hide=(phone:string)=>{const count=(phone.match(/\d/g)||[]).length;let index=0;return phone.replace(/\d/g,digit=>{const at=index++;return at>=3 && at<count-2?'*':digit})}
 // 完整手机号（含国家码/空格/连字符）、固话和400/800号码，均要求独立数字边界。
 text=text.replace(/(^|[^\d])((?:(?:\+?86|0086)[ \t-]*)?1[3-9]\d(?:[ \t-]*\d){8})(?=$|[^\d])/g,(_,prefix,phone)=>prefix+hide(phone))
 text=text.replace(/(^|[^\d])((?:0\d{2,3}[ \t-]*|\(0\d{2,3}\)[ \t-]*|（0\d{2,3}）[ \t-]*)\d{7,8})(?=$|[^\d])/g,(_,prefix,phone)=>prefix+hide(phone))
 text=text.replace(/(^|[^\d])((?:400|800)[ \t-]*\d{3}[ \t-]*\d{4})(?=$|[^\d])/g,(_,prefix,phone)=>prefix+hide(phone))
 // 无区号短号码仅在明确电话标签后处理，避免误伤邮编、门牌数字。
 text=text.replace(/((?:电话|手机|联系电话|联系方式|tel(?:ephone)?)[ \t:：]*)(\d{7,8})(?=$|[^\d])/gi,(_,label,phone)=>label+hide(phone))
 return original.split('').map((char,index)=>text[index]==='*' && normalized[index]!=='*'?'*':char).join('')
}
export function safeAddressText(value:unknown,canViewPhone:boolean):string {
 const text=value==null?'':String(value)
 return canViewPhone?text:maskAddressPhones(text)
}
